module.exports = __webpack_public_path__ + "static/media/daniel_mentor_headshot.43fd9be6.jpeg";